import {SHOWANIMATIONFORM, HIDEANIMATIONFORM} from '../types'

const initState = {
  show: false,
  nameForm: '',
  title: '',
  value: '',
}

const animationForm = (state = initState, action) => {
  switch(action.type){
    case SHOWANIMATIONFORM:
      return {...state, show: true, nameForm: action.name, title: action.title, value: action.value}
    case HIDEANIMATIONFORM:
      return {...state, show: false, nameForm: '', title: '', value:''}
    default:
      return state
  }
}

export default animationForm